import * as S from "./styles";

import { Page } from "components/Page";
import { BreadcrumbsProps } from "components/BreadCrumb";
import { useHistory } from "react-router-dom";
import { useMemo } from "react";
import { DefaultFooter } from "components/DefaultFooter";
import { Button } from "components/Button";

import itauImage from "assets/images/itau.png";
import bradescoImage from "assets/images/bradesco.png";
import banestesImage from "assets/images/banestes.png";
import caixaImage from "assets/images/caixa.png";
import bancoDoBrasilImage from "assets/images/banco-do-brasil.png";
import santanderImage from "assets/images/santander.png";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";
import { ButtonContact } from "components/ButtonContact";

export function ComercialTaxas() {
  const history = useHistory();

  const breadcrumbs: BreadcrumbsProps = useMemo(() => {
    return {
      paths: [
        {
          link: "/",
          title: "Página inicial",
        },
        {
          link: "/modalidade",
          title: "Modalidade",
        },
        {
          link: "/financiamento",
          title: "Financiamento",
        },
      ],
      currentPage: "Comercial",
    };
  }, []);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <S.Title>Compare as taxas dos principais bancos:</S.Title>

      <S.Content>
        <S.ContainerBanks>
          <S.BankItem>
            <img src={banestesImage} alt="Logo Banestes" />
            <div>
              <strong>Banestes</strong>
              <p>8,99% + TR efetivo, até 80% até 240 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={bradescoImage} alt="Logo Bradesco" />
            <div>
              <strong>Bradesco</strong>
              <p>11% + TR efetivo, até 70% até 120 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={caixaImage} alt="Logo Caixa Econômica" />
            <div>
              <strong>Caixa Econômica</strong>
              <p>8,25% + TR efetivo, até 70% até 240 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={bancoDoBrasilImage} alt="Logo Banco do Brasil" />
            <div>
              <strong>Banco do Brasil</strong>
              <p>8,85 % a 10,60% até 80% até 360 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={itauImage} alt="Logo Itaú" />
            <div>
              <strong>Itaú</strong>
              <p>10% até 70% até 240 meses.</p>
            </div>
          </S.BankItem>

          <S.BankItem>
            <img src={santanderImage} alt="Logo Santander" />
            <div>
              <strong>Santander</strong>
              <p>11,30% a 11,51%.</p>
            </div>
          </S.BankItem>

        </S.ContainerBanks>
      </S.Content>
      <S.WrapperButtons>
        <Button
          onClick={() => history.push("/financiamento")}
          startIcon={<IconArrowBack />}
          variant="outlined"
        >
          VOLTAR
        </Button>

        <ButtonContact />
      </S.WrapperButtons>

      <DefaultFooter />
    </Page>
  );
}
